import Link from '@/components/client/seo/link'
import { CouponCallout } from '@/components/client/shared/coupon-callout'

import type { ListicleCardProps } from './types'

export const ListicleCardHeading = ({ card, text }: ListicleCardProps) => {
  const {
    name,
    isTopPick,
    topPickText,
    badge,
    basePrice,
    discountPrice,
    hasDiscount,
    priceSuffix,
    productUrl,
    coupon,
    affiliateUrl,
  } = card
  return (
    <div className="mb-6 flex flex-col justify-between gap-6 md:flex-row md:items-start">
      <div className="space-y-3">
        <div className={`flex items-center ${isTopPick ? 'mb-1 gap-3' : '!mb-0 pb-1'}`}>
          {isTopPick && (
            <span className="bg-navy rounded px-2.5 py-0.5 text-[10px] font-bold tracking-wider whitespace-nowrap text-white uppercase">
              {topPickText}
            </span>
          )}
          {badge && <span className="text-lapis text-xs font-bold tracking-wide uppercase">{badge}</span>}
        </div>

        <div className="text-navy !mb-2 text-3xl font-bold">
          {productUrl ? (
            <Link
              href={productUrl}
              prefetch={false}
              data-tracking="ignore"
              className="hover:text-lapis transition-colors"
            >
              {name}
            </Link>
          ) : (
            <span>{name}</span>
          )}
        </div>

        <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm">
          {hasDiscount && <span className="text-slate-400 line-through">{basePrice}</span>}
          {basePrice && (
            <span className="text-navy font-semibold">
              {text.from} {hasDiscount ? discountPrice : basePrice}
              {priceSuffix}
            </span>
          )}
          {coupon && (coupon.message || coupon.amountOff || coupon.percentOff) && (
            <>
              <span className="text-navy">|</span>
              <CouponCallout
                coupon={coupon}
                affiliateUrl={affiliateUrl}
                sellerName={card.resolvedSellerName}
                tracking={{
                  position: 'listicle-card-coupon',
                  product: card.resolvedReleaseSlug ?? '',
                  seller: card.resolvedSellerName,
                  sellerType: card.resolvedSellerType,
                }}
                label={card.couponLabel ?? ''}
                text={text.coupon}
              />
            </>
          )}
          {productUrl && (
            <>
              {(basePrice || coupon) && <span className="text-navy">|</span>}
              <Link href={productUrl} prefetch={false} data-tracking="ignore" className="text-lapis hover:underline">
                {text.readFullReview}
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
